import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ImageAuthorized = ({ src, style, alt = '' }) => {
  const [imageData, setImageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('No authentication token found');
          return;
        }

        const response = await axios.get(src, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'arraybuffer',
        });

        
        
        // Convert arraybuffer to base64
        const base64 = btoa(
          new Uint8Array(response.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        );
        
        // Create data URL with proper MIME type
        const mimeType = response.headers['content-type'] || 'image/jpeg';
        const dataUrl = `data:${mimeType};base64,${base64}`;
        
        setImageData(dataUrl);
        setLoading(false);
      } catch (err) {
        console.log('Amma3 Error fetching image:', err);
        //alert(err.message);
        setLoading(false);
      }
    };

    fetchImage();
  }, [src]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return <img src={imageData} style={style} alt={alt} />;
};

export default ImageAuthorized; 